import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// Include call API
import { getMapAPI } from "../../../api/map";
import { getMapPositionsError, getMapPositionsSuccess } from "./actions";
// Login Redux States
import { GET_MAP_POSITIONS } from "./actionTypes";

const mapAPI = getMapAPI();

function* getMapPositionsApi({ payload: { user, history } }) {
  try {
    const response = yield call(mapAPI.getMapPositions, user.token);
    yield put(getMapPositionsSuccess(response.message, response.map_positions));
  } catch (error) {
    yield put(getMapPositionsError(error));
  }
}

export function* watchgetMapPositions() {
  yield takeEvery(GET_MAP_POSITIONS, getMapPositionsApi);
}

function* getMapPositionsSaga() {
  yield all([fork(watchgetMapPositions)]);
}

export default getMapPositionsSaga;
